import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../api/auth';

const ForgetPassword = () => {
    const [formData, setFormData] = useState({
        email: '',
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [isSent, setIsSent] = useState(false);
    const navigate = useNavigate();

    const handleChange = e => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            await resetPassword(formData.email);
            console.log('Password reset email sent successfully');

            setIsSent(true);
            setErrorMessage('');
        } catch (e) {
            console.log(e);
            setIsSent(false);
            setErrorMessage('We cannot find your email. Please try again.');
        }
    };

    return (
        <div className='flex justify-center flex-col my-1 items-center h-full'>
            <div className="bg-white rounded-4 rounded-b-3xl w-full shadow p-6 max-w-md">
                <div className="flex flex-col items-center" data-cy='headers'>
                    <h1 className="font-bold text-8 my-3">Forgot Password</h1>
                    <h2 className="text-base font-normal">Enter your registered email address and we&apos;ll send you a link to reset your password.</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            type='email'
                            placeholder='Email Address'
                            name='email'
                            onChange={handleChange}
                            required
                            className='mb-2 w-full py-3 px-3.5 border-solid border-1 border-black rounded-2 font-400 text-4 cursor-pointer'
                            data-cy='email'
                        />
                    </div>

                    {errorMessage && <p className='text-red text-4 font-normal' data-cy='error-message'>{errorMessage}</p>}
                    {isSent && <p className='text-green text-4 font-normal'>Email sent successfully!</p>}
                    <button className='font-semibold w-100 py-2 px-1 rounded-3 text-4 bg-yellow mt-3 mx-auto border-black border-solid border-1' data-cy='submit'>Submit</button>
                </form>

                <div className='flex items-center justify-center mt-4' data-cy='redirect'>
                    <a href='' onClick={() => navigate('/login')}>
                        Back to Login
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ForgetPassword;
